import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/aivoice/pic_kongyinpin.svg'


const _hoisted_1 = { class: "hisEditTitle" }
const _hoisted_2 = { class: "hisEditList" }
const _hoisted_3 = { class: "logShowtype" }
const _hoisted_4 = { class: "onePublicTitle" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  key: 0,
  class: "onePublicBoxIn"
}
const _hoisted_9 = { class: "boxInTop" }
const _hoisted_10 = { class: "boxInTopLeft" }
const _hoisted_11 = { class: "boxInTopLeftLine" }
const _hoisted_12 = { class: "boxInTopLeftTime" }
const _hoisted_13 = { class: "boxInTopRight" }
const _hoisted_14 = { class: "boxInBtm" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = {
  key: 3,
  class: "subitemImgBox"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "subitemLeft" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "listBoxIn" }
const _hoisted_22 = { class: "listBoxInTitle" }
const _hoisted_23 = { class: "listBoxInTitleLeft" }
const _hoisted_24 = { class: "originalTextStyle" }
const _hoisted_25 = { class: "replaceTextStyle" }
const _hoisted_26 = { class: "listBoxInTitleRight" }
const _hoisted_27 = { class: "btnRight" }
const _hoisted_28 = { class: "listBoxInBox" }
const _hoisted_29 = { class: "listBoxInOnetop" }
const _hoisted_30 = { class: "listBoxInOneLeftLine" }
const _hoisted_31 = { class: "listBoxInOneLeftTime" }
const _hoisted_32 = {
  key: 1,
  class: "noDataImg"
}

import headPic from '@/assets/aivoice/ico_morentouxiang.svg';
import {
    Close,
    CaretTop,
    CaretBottom,
} from "@element-plus/icons-vue";
import { ref, onMounted,getCurrentInstance,watch,nextTick} from 'vue'
// 时间处理方法
import { timedataYmd, timedataHm ,timeInfo} from '@/components/public-method/time-method';
import {controlType } from "./icon.ts"

export default /*@__PURE__*/_defineComponent({
  __name: 'allHistory',
  props: {
    allLog:Array,
    initdata:Array,
    imgs:Array,
    roles:Array,

},
  emits: ['closeThis',''],
  setup(__props, { emit: __emit }) {

const props = __props
// 引入页面图标
let { proxy } = getCurrentInstance()
const emit = __emit
// 关闭弹窗
const closeBox=()=>{
    emit('closeThis')
}
// 批量替换展示
const reFindShow=ref([])
const showData=ref()
const activeNames=ref([])
// 隐藏
const hideList=(key:string)=>{
    reFindShow.value.push(key)
}
const showListfun=(key:string)=>{
    let index = reFindShow.value.indexOf(key); // 找到要删除的元素的索引
    if (index > -1) {
        reFindShow.value.splice(index, 1); // 删除该元素
    }
  
}
onMounted(()=>{
    // console.log('历史记录')
    console.log(props.allLog)
    if(props.allLog.length>0){
        showData.value=groupBySameDay(JSON.parse(JSON.stringify(props.allLog)))
        // console.log(showData.value)
        nextTick(()=>{
            for(let key in showData.value){
                activeNames.value.push(key)
            }
        })
    }
    
})
// 将数据文件按照时间划分数组
const groupBySameDay=(array:any, timestampKey = 'createTime', userKey = 'userId',batchKey='batch')=> {
  return array.sort((a, b) => b.createTime - a.createTime).reduce((acc:any, item:any) => {
    if(item.batch ==undefined){
        item.batch='batchNo'
    }
    // 将时间戳转换为日期对象
    const date = new Date(item[timestampKey]*1);
    // 创建只包含年月日的日期字符串作为键
    const dayKey = date.toLocaleDateString('en-CA'); // 格式: YYYY-MM-DD
    
    if (!acc[dayKey]) {
      acc[dayKey] = {};
    }
    
    // 然后在每一天内按用户分组
    const userId = item[userKey];
    if (!acc[dayKey][userId]) {
      acc[dayKey][userId] = {};
    }
    // 每一天内按用户分组区分是否为批量
    const batchId=item[batchKey];
    if (!acc[dayKey][userId][batchId]) {
      acc[dayKey][userId][batchId] = [];
    }
      
    acc[dayKey][userId][batchId].push(item);
    return acc;
  }, {});
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: "hisEditBox",
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("span", null, "编辑记录", -1)),
      _createElementVNode("span", {
        class: "closeBtn",
        onClick: _withModifiers(closeBox, ["stop"])
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(Close))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (showData.value!=null)
        ? (_openBlock(), _createBlock(_component_el_scrollbar, {
            key: 0,
            height: "100%"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_collapse, {
                  modelValue: activeNames.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeNames).value = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showData.value, (value, key) => {
                      return (_openBlock(), _createBlock(_component_el_collapse_item, {
                        title: key,
                        key: key,
                        name: key
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (it, itkey) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: itkey,
                              class: "onePublic"
                            }, [
                              _createElementVNode("div", _hoisted_4, [
                                (props.imgs.length>0&&props.imgs.filter(its=>its.userId==itkey)[0].avatar != undefined&&props.imgs.filter(its=>its.userId==itkey)[0].avatar !='')
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: _unref(proxy).getimgUrl+props.imgs.filter(its=>its.userId==itkey)[0].avatar,
                                      alt: ""
                                    }, null, 8, _hoisted_5))
                                  : _createCommentVNode("", true),
                                (props.imgs.length==0||props.imgs.filter(its=>its.userId==itkey)[0].avatar == undefined||props.imgs.filter(its=>its.userId==itkey)[0].avatar =='')
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      src: _unref(headPic),
                                      alt: ""
                                    }, null, 8, _hoisted_6))
                                  : _createCommentVNode("", true),
                                (props.imgs.length>0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(props.imgs.filter(its=>its.userId==itkey)[0].nickname), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(it, (itone, itonekey) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: itonekey,
                                  class: "onePublicBox"
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itone, (one, oneIndex) => {
                                    return (_openBlock(), _createElementBlock("div", { key: oneIndex }, [
                                      (itonekey=='batchNo')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _createElementVNode("div", _hoisted_9, [
                                              _createElementVNode("div", _hoisted_10, [
                                                _createElementVNode("span", _hoisted_11, "序号 " + _toDisplayString(one.line +1), 1),
                                                _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(controlType).filter(its=>its.value==one.type)[0].text), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_13, [
                                                _createElementVNode("span", null, _toDisplayString(_unref(timedataHm)(one.createTime*1)), 1)
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_14, [
                                              (one.type=='modifyOriginalText'||one.type=='modifyTranslationText'||one.type=='originalTextReplace'||one.type=='translationTextReplace'||one.type=='delete')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(one.data.text), 1))
                                                : _createCommentVNode("", true),
                                              (one.type=='modifyOriginalColor'||one.type=='modifyTranslationColor')
                                                ? (_openBlock(), _createElementBlock("span", {
                                                    key: 1,
                                                    style: _normalizeStyle({background:one.data.textColor}),
                                                    class: "subitemColor"
                                                  }, null, 4))
                                                : _createCommentVNode("", true),
                                              (one.type=='modifyTime')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(timeInfo)(one.data.beginTime )) + " -- " + _toDisplayString(_unref(timeInfo)(one.data.endTime )), 1))
                                                : _createCommentVNode("", true),
                                              (one.type=='modifyRole')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                    _createElementVNode("img", {
                                                      src: _unref(proxy).getimgUrl+props.roles.filter(it=>it.id==one.data.role)[0].avatar,
                                                      alt: ""
                                                    }, null, 8, _hoisted_18),
                                                    _createElementVNode("span", _hoisted_19, _toDisplayString(props.roles.filter(it=>it.id==one.data.role)[0].name), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128)),
                                  (itonekey!='batchNo')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                        _createElementVNode("div", _hoisted_21, [
                                          _createElementVNode("div", _hoisted_22, [
                                            _createElementVNode("div", _hoisted_23, [
                                              _cache[3] || (_cache[3] = _createTextVNode(" [ ")),
                                              _createElementVNode("span", _hoisted_24, _toDisplayString(itone[0].data.originalText), 1),
                                              _cache[4] || (_cache[4] = _createTextVNode(" ] ")),
                                              _cache[5] || (_cache[5] = _createElementVNode("span", null, "替换为", -1)),
                                              _cache[6] || (_cache[6] = _createTextVNode(" [ ")),
                                              _createElementVNode("span", _hoisted_25, _toDisplayString(itone[0].data.replaceText), 1),
                                              _cache[7] || (_cache[7] = _createTextVNode(" ] "))
                                            ]),
                                            _createElementVNode("div", _hoisted_26, [
                                              _cache[8] || (_cache[8] = _createElementVNode("span", null, "查找/替换", -1)),
                                              _createElementVNode("span", _hoisted_27, [
                                                _withDirectives(_createVNode(_component_el_icon, {
                                                  onClick: _withModifiers(($event: any) => (showListfun(itonekey)), ["stop"])
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(CaretBottom))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]), [
                                                  [_vShow, reFindShow.value.indexOf(itonekey)>=0]
                                                ]),
                                                _withDirectives(_createVNode(_component_el_icon, {
                                                  onClick: _withModifiers(($event: any) => (hideList(itonekey)), ["stop"])
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(CaretTop))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]), [
                                                  [_vShow, reFindShow.value.indexOf(itonekey)<0]
                                                ])
                                              ]),
                                              _createElementVNode("span", null, _toDisplayString(_unref(timedataHm)(itone[0].createTime*1)), 1)
                                            ])
                                          ]),
                                          _withDirectives(_createElementVNode("div", _hoisted_28, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itone, (one, oneIndex) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                class: "listBoxInOne",
                                                key: oneIndex
                                              }, [
                                                _createElementVNode("div", _hoisted_29, [
                                                  _createElementVNode("span", _hoisted_30, "序号 " + _toDisplayString(one.line), 1),
                                                  _createElementVNode("span", _hoisted_31, _toDisplayString(one.data.text), 1)
                                                ])
                                              ]))
                                            }), 128))
                                          ], 512), [
                                            [_vShow, reFindShow.value.indexOf(itonekey)<0]
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["title", "name"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (showData.value==null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, _cache[9] || (_cache[9] = [
            _createElementVNode("div", { class: "imgBox" }, [
              _createElementVNode("img", { src: _imports_0 }),
              _createElementVNode("div", null, "暂无数据")
            ], -1)
          ])))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})